import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from '@/App.vue';

import enMessages from '@/locales/en.json';
import ruMessages from '@/locales/ru.json';

const messages = {
    en: enMessages,
    ru: ruMessages,
};

const fallbackLocale = 'en';
//NOTE: AppConfig is a global variable set in the parent web page
const locale = window.AppConfig?.locale || fallbackLocale;

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale,
  messages,
});

const app = createApp(App);
app.use(i18n);
app.mount('#app-support-us');
